// Carries the "you were logged out" banner to the login page. Auto-logout uses
// an in-memory flag (signinRedirect adds sessionExpired=1); manual logout and
// callback errors use sessionStorage, which survives the redirect.

import { AUTH_SESSION_KEYS } from "@/constants/authFlowKeys";
import { authSessionStorage } from "./authStorage";

const STORAGE_KEY = AUTH_SESSION_KEYS.LOGGED_OUT_MESSAGE;

export const IDLE_LOGOUT_MESSAGE =
  "Your session has expired. Please log in again to continue using Engage.";

let pendingSessionExpired = false;

export const setLoggedOutMessage = (message) => {
  authSessionStorage.set(STORAGE_KEY, message);
};

export const markSessionExpired = () => {
  pendingSessionExpired = true;
};

// Returns true once if markSessionExpired() was called, then clears the flag.
export const consumeSessionExpiredFlag = () => {
  if (pendingSessionExpired) {
    pendingSessionExpired = false;
    return true;
  }
  return false;
};

// The URL param (auto-logout) wins over a stored message (manual logout/error).
export const resolveLoggedOutMessage = (searchParams) => {
  if (searchParams?.get("sessionExpired") === "1") {
    return IDLE_LOGOUT_MESSAGE;
  }

  const message = authSessionStorage.get(STORAGE_KEY);
  if (message) {
    authSessionStorage.remove(STORAGE_KEY);
  }
  return message || null;
};
